// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0.0.13/static/css/" + "main" + "." + "ed1ea796" + ".css";
};